import {API_DRIVER} from "../configs/axios";

const getDeviceBaseUrl = (endpoint) => {
    return `/api/v2/devices${endpoint ?? ""}`;
}

const DeviceService = {
    fetchVendita: (page, size, sortBy, sortOrder,
                   integrationId,
                   imei,
                   prodotto,
                   tags,
                   collaborators,
                   descrizione,
                   contratto,
                   idSpedizione,
                   tipologiaDiVendita,
                   assistenza,
                   dataTermineAssistenza,
                   interventiInAssistenza,
                   dataConsegnaAfter,
                   dataConsegnaBefore) => {
        return API_DRIVER.get(getDeviceBaseUrl(`/vendita`), {
            params: {
                page,
                size,
                sortBy,
                sortOrder,
                integrationId,
                imei,
                prodotto,
                tags,
                collaborators,
                descrizione,
                contratto,
                idSpedizione,
                tipologiaDiVendita,
                assistenza,
                dataTermineAssistenza,
                interventiInAssistenza,
                dataConsegnaAfter,
                dataConsegnaBefore
            }
        });
    },
    fetchNoleggio: (page, size, sortBy, sortOrder,
                    integrationId,
                    imei,
                    prodotto,
                    tags,
                    collaborators,
                    descrizione,
                    contratto,
                    idSpedizione,
                    tipologiaDiVendita,
                    assistenza,
                    dataTermineAssistenza,
                    interventiInAssistenza,
                    dataConsegnaAfter,
                    dataConsegnaBefore) => {
        return API_DRIVER.get(getDeviceBaseUrl(`/noleggio`), {
            params: {
                page,
                size,
                sortBy,
                sortOrder,
                integrationId,
                imei,
                prodotto,
                tags,
                collaborators,
                descrizione,
                contratto,
                idSpedizione,
                tipologiaDiVendita,
                assistenza,
                dataTermineAssistenza,
                interventiInAssistenza,
                dataConsegnaAfter,
                dataConsegnaBefore
            }
        })
    },
    fetchRestituzioni: (page,
                        size,
                        sortBy,
                        sortOrder,
                        integrationId,
                        imei,
                        prodotto,
                        tags,
                        collaborators,
                        descrizione,
                        contratto,
                        idSpedizione,
                        tipologiaDiVendita,
                        assistenza,
                        dataTermineAssistenza,
                        interventiInAssistenza,
                        dataConsegnaAfter,
                        dataConsegnaBefore,
                        statoRestituzione) => {
        return API_DRIVER.get(getDeviceBaseUrl(`/restituzioni`), {
            params: {
                page,
                size,
                sortBy,
                sortOrder,
                integrationId,
                imei,
                prodotto,
                tags,
                collaborators,
                descrizione,
                contratto,
                idSpedizione,
                tipologiaDiVendita,
                assistenza,
                dataTermineAssistenza,
                interventiInAssistenza,
                dataConsegnaAfter,
                dataConsegnaBefore,
                statoRestituzione,
            }
        })
    },
    fetchNoleggioInScadenza: (
        page,
        size,
        sortBy,
        sortOrder,
        integrationId,
        imei,
        prodotto,
        tags,
        collaborators,
        descrizione,
        contratto,
        idSpedizione,
        tipologiaDiVendita,
        assistenza,
        dataTermineAssistenza,
        interventiInAssistenza,
        dataConsegnaAfter,
        dataConsegnaBefore
    ) => {
        return API_DRIVER.get(getDeviceBaseUrl(`/noleggio-in-scadenza`), {
            params: {
                page,
                size,
                sortBy,
                sortOrder,
                integrationId,
                imei,
                prodotto,
                tags,
                collaborators,
                descrizione,
                contratto,
                idSpedizione,
                tipologiaDiVendita,
                assistenza,
                dataTermineAssistenza,
                interventiInAssistenza,
                dataConsegnaAfter,
                dataConsegnaBefore,
            },
        });
    },
    fetchDeviceDetails: (imei, integrationId) => {
        return API_DRIVER.get(getDeviceBaseUrl(`/${imei}/customer/${integrationId}`))
    },
    fetchWrenchDetails: (body) => {
        return API_DRIVER.post("/api/device/wrenchDetails", body)
    },
    fetchDeviceTabsCount: (integrationId,
                           tabName,
                           imei,
                           prodotto,
                           tags,
                           collaborators,
                           descrizione,
                           contratto,
                           idSpedizione,
                           tipologiaDiVendita,
                           assistenza,
                           dataTermineAssistenza,
                           interventiInAssistenza,
                           dataConsegnaAfter,
                           dataConsegnaBefore) => {
        return API_DRIVER.get(getDeviceBaseUrl(`/group-count`), {
            params: {
                integrationId,
                tabName,
                imei,
                prodotto,
                tags,
                collaborators,
                descrizione,
                contratto,
                idSpedizione,
                tipologiaDiVendita,
                assistenza,
                dataTermineAssistenza,
                interventiInAssistenza,
                dataConsegnaAfter,
                dataConsegnaBefore
            }
        })
    },
    fetchRestituzioniDetails: (integrationId, nOrdineReso) => {
        return API_DRIVER.get(`/api/v2/devices/${integrationId}/restituzioni/${nOrdineReso}`)
    },
    fetchRestituzioniDetailsTable: (integrationId,
                                    nOrdineReso,
                                    page,
                                    size,
                                    sortBy,
                                    sortOrder,
                                    imei,
                                    prodotto,
                                    tags,
                                    collaborators,
                                    descrizione,
                                    contratto,
                                    idSpedizione,
                                    tipologiaDiVendita,
                                    assistenza,
                                    dataTermineAssistenza,
                                    interventiInAssistenza,
                                    dataConsegnaAfter,
                                    dataConsegnaBefore,
                                    statoRestituzione,
                                    valutazioneDevice) => {
        return API_DRIVER.get(getDeviceBaseUrl(`/${integrationId}/restituzioni/${nOrdineReso}/devices`), {
            params: {
                page,
                size,
                sortBy,
                sortOrder,
                prodotto,
                tags,
                collaborators,
                descrizione,
                contratto,
                idSpedizione,
                tipologiaDiVendita,
                assistenza,
                dataTermineAssistenza,
                interventiInAssistenza,
                dataConsegnaAfter,
                dataConsegnaBefore,
                imei,
                statoRestituzione,
                valutazioneDevice
            }
        })
    },
    downloadVenditaCsv: (selectedSims, query, areAllSelected) => {
        return API_DRIVER.post(`/api/v2/devices/vendita/download-csv?${query}&areAllSelected=${areAllSelected}`, selectedSims, {
            responseType: 'blob'
        })
    },
    downloadNoleggioCsv: (selectedSims, query, areAllSelected) => {
        return API_DRIVER.post(`/api/v2/devices/noleggio/download-csv?${query}&areAllSelected=${areAllSelected}`, selectedSims, {
            responseType: 'blob'
        })
    },
    downloadNoleggioInScadenzaCsv: (selectedSims, query, areAllSelected) => {
        return API_DRIVER.post(`/api/v2/devices/noleggio-in-scadenza/download-csv?${query}&areAllSelected=${areAllSelected}`, selectedSims, {
            responseType: 'blob'
        })
    },
    downloadNoleggioScadutoCsv: (selectedSims, query, areAllSelected) => {
        return API_DRIVER.post(`/api/v2/devices/noleggio-scaduto/download-csv?${query}&areAllSelected=${areAllSelected}`, selectedSims, {
            responseType: 'blob'
        })
    },
      //TODO: /restituzioni/download-csv not implemented in the backend
      downloadRestituzioniCsv: (selectedSims, query, areAllSelected) => {
        return API_DRIVER.post(`/api/v2/devices/restituzioni/download-csv?${query}&areAllSelected=${areAllSelected}`, selectedSims, {
            responseType: 'blob'
        })
    },
    //TODO: not implemented in the backend
    downloadRestituzioniDetailsCsv: (integrationId, nOrdineReso, selectedDevices) => {
        return API_DRIVER.post(getDeviceBaseUrl(`/${integrationId}/restituzioni/${nOrdineReso}/devices/download-csv`), selectedDevices, {
            responseType: 'blob'
        })
    },

}

export default DeviceService;